import { DropDown } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Typography } from '@mui/material';
import { memo } from 'react';
import { useCompanyStatsContext } from '../../context';
import { STATS_OPTIONS } from './constants';
import * as Styled from './styles';
import * as SX from './sx';
import type { SelectStatsProps as Props } from './types';

export const SelectStats = memo(({ className }: Props) => {
  const { statsType, handleChangeStats } = useCompanyStatsContext();

  return (
    <Styled.Wrapper
      className={classnames('SelectStats', className)}
      sx={SX.root}
    >
      <Typography variant="body2" fontWeight={600} color="grey.800" flex={3}>
        Global View
      </Typography>

      <Box flex={1}>
        <DropDown
          size="small"
          options={STATS_OPTIONS}
          value={statsType}
          onChange={handleChangeStats}
        />
      </Box>
    </Styled.Wrapper>
  );
});

SelectStats.displayName = 'SelectStats';
